import Image from "next/image";
import Link from "next/link";

const SIZES = {
  default: { width: 160, height: 44, className: "h-9 md:h-10 w-auto" },
  small: { width: 128, height: 36, className: "h-8 w-auto" },
} as const;

export function Logo({ size = "default" }: { size?: keyof typeof SIZES }) {
  const { width, height, className } = SIZES[size];
  return (
    <Link href="/" aria-label="CodeWithT — Home" className="flex items-center group">
      <Image
        src="/images/logo-light.webp"
        alt="CodeWithT"
        width={width}
        height={height}
        className={`${className} block dark:hidden`}
      />
      <Image
        src="/images/logo-dark.webp"
        alt="CodeWithT"
        width={width}
        height={height}
        className={`${className} hidden dark:block`}
      />
    </Link>
  );
}
